import { render } from "./ListExamStandard.vue?vue&type=template&id=cc4b84f0"
import script from "./ListExamStandard.vue?vue&type=script&lang=js"
export * from "./ListExamStandard.vue?vue&type=script&lang=js"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-teacher-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__